export const IS_GLOBAL = 'global';
export const IS_REGULAR = 'regular';
export const IS_SINGLE = 'single';
export const IS_DELAYED = 'delayed';

export const WILL_BE_REMOVED = 'willBeRemoved';
export const WILL_BE_CREATED = 'willBeCreated';

export const MAX_TITLE_LENGTH = 300;
export const MAX_NOTES_LENGTH = 1500;
export const TASKS_NUMBER_COLOR_RED = 80;
export const MAX_LABEL_LENGTH = 50;
export const MAX_FULL_NAME_LENGTH = 50;
export const SVG_STAT_CONST = 251.2;
export const TASKS_PER_PAGE = 15;

export const NO_TASKS_COLOR = '#fff';
export const NOT_DONE_TASKS_COLOR = '#f1f1f1';
export const ALL_DONE_TASKS_COLOR = '#f48b00';
export const ALL_NOT_DONE_TASKS_OVERDUED_COLOR = '#3e3e3e';
export const SOME_DONE_TASKS_COLOR = '#edc590';

export const TOTAL_TIME_NEED_PER_DAY_MAX = 15;

export const DAY_IN_MILLISECONDS = 86400000;
export const INTERVAL_NAMES = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
};

export const SEARCH = {
  title: 'title',
  subtitle: 'subtitle',
  description: 'description',
  note: 'note',
};

export const FILTER = {
  type: 'type',
  // startDate: 'startDate',
  // date: 'date',
  isImportant: 'importance',
  isDone: 'done',
  // time: 'time',
  // timeNeed: 'timeNeed',
  labels: 'labels',
};

export const SORT = {
  title: 'title',
  startDate: 'startDate',
  date: 'date',
  isImportant: 'importance',
  isDone: 'done',
  time: 'time',
  timeNeed: 'timeNeed',
  labels: 'labels',
};

export const LABEL_COLORS = ['#6870de', '#d1d0fe', '#4fb262', '#d12f10', '#ff762f', '#daa8ae', '#f6b659', '#94efd3', '#a3a3a3', '#84b7ee'];

export const BROADCAST_CHANNEL_PURPORT = 'purport-app-web';
